// src/components/MyRestaurants/MyRestaurants.jsx (o la ruta donde lo tengas)
import React, { useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import useStore from "../../../useStore";
import Loader from "../../Elements/Loader/Loader";
import Button from "../../Elements/Button/Button";
import RestaurantGrid from "../RestaurantHome/RestaurantGrid/RestaurantGrid";
import "./myRestaurants.css";

// 👇 importa el servicio que ya tienes en Web
import { fetchOrdersByRestaurant } from "../../../Services/fetchGetOrdersByRestaurant";

const MyRestaurants = () => {
  const { fetchDataGetMyRestaurants, restaurants, loading, error } = useStore();
  const [user, setUser] = useState(null);

  // mapa: { [restauranteId]: { has: boolean, checking: boolean } }
  const [pendingMap, setPendingMap] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    const data = localStorage.getItem("logindata");
    if (data) {
      try { setUser(JSON.parse(data)); } catch { }
    }
  }, []);

  useEffect(() => {
    fetchDataGetMyRestaurants();
  }, [fetchDataGetMyRestaurants]);

  const userId = user?.data?.userId || null;

  const myRestaurants = useMemo(() => {
    const list = Array.isArray(restaurants) ? restaurants : [];
    if (!userId) return [];
    return list.filter(r => String(r?.createdByUserId || "") === String(userId));
  }, [restaurants, userId]);

  const goToDetail = (id) => id && navigate(`/restaurants/${id}`);

  // 🔔 Construir alertas de pedidos (pendiente/preparando) para cada restaurante del usuario
  useEffect(() => {
    let cancelled = false;

    const run = async () => {
      if (!userId) { setPendingMap({}); return; }

      const ids = myRestaurants
        .map(r => String(r?.restauranteId ?? r?.id ?? ""))
        .filter(Boolean);

      if (ids.length === 0) { setPendingMap({}); return; }

      // marca como "checking" mientras cargan
      setPendingMap(prev => {
        const next = { ...prev };
        ids.forEach(id => { next[id] = { ...(next[id] || {}), checking: true }; });
        return next;
      });

      try {
        const results = await Promise.allSettled(ids.map(id => fetchOrdersByRestaurant(id)));
        if (cancelled) return;

        const next = {};
        results.forEach((res, idx) => {
          const id = ids[idx];
          if (res.status === "fulfilled") {
            const items = Array.isArray(res.value?.items) ? res.value.items : [];
            const has = items.some(o => {
              const s = String(o?.status ?? "").trim().toLowerCase();
              return s === "pendiente" || s === "preparando";
            });
            next[id] = { has, checking: false };
          } else {
            next[id] = { has: false, checking: false };
          }
        });

        setPendingMap(next);
      } catch {
        if (!cancelled) {
          const fallback = {};
          ids.forEach(id => { fallback[id] = { has: false, checking: false }; });
          setPendingMap(fallback);
        }
      }
    };

    run();
    return () => { cancelled = true; };
  }, [myRestaurants, userId]);

  return (
    <section className="my-restaurants container-fluid container-mh">
      <div className="row align-items-center my-head g-2">
        <div className="col-12 col-md-8">
          <h2 className="my-h2">Mis Comercios 🍴</h2>
          {user && (
            <>
              <p className="muted mb-0">Usuario ID: {user?.data?.userId}</p>
              <p className="muted">Email: {user?.data?.email}</p>
            </>
          )}
        </div>
        <div className="col-12 col-md-4 d-flex justify-content-md-end">
          <Button
            text="Volver"
            color="blue"
            fill
            action={() => navigate(-1)}
            classNames="my-back-btn w-100 w-md-auto"
          />
        </div>
      </div>

      {loading && <Loader />}
      {error && <p className="error">{error}</p>}

      {!loading && !error && myRestaurants.length === 0 && (
        <p className="muted empty-msg">Aún no has registrado ningún comercio.</p>
      )}

      <div className="row">
        <div className="col-12">
          {/* 👇 Pasamos el mapa de alertas al grid */}
          <RestaurantGrid
            items={myRestaurants}
            onOpenDetail={goToDetail}
            pendingMap={pendingMap}
          />
        </div>
      </div>
    </section>
  );
};

export default MyRestaurants;